var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDowntown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0665 11.0222H5.02283V19.7558H19.0665V11.0222ZM4.02283 10.0222V20.7558H20.0665V10.0222H4.02283Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1474 15.8352H9.94189V19.7558H14.1474V15.8352ZM8.94189 14.8352V20.7558H15.1474V14.8352H8.94189Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0768 3.59429C12.2094 3.59429 12.3366 3.64697 12.4304 3.74074L16.2635 7.57385H20.036C20.3121 7.57385 20.536 7.79771 20.536 8.07385C20.536 8.34999 20.3121 8.57385 20.036 8.57385H16.0564C15.9238 8.57385 15.7966 8.52117 15.7028 8.42741L12.0768 4.8014L8.45083 8.42741C8.35706 8.52117 8.22988 8.57385 8.09728 8.57385H3.97027C3.69413 8.57385 3.47027 8.34999 3.47027 8.07385C3.47027 7.79771 3.69413 7.57385 3.97027 7.57385H7.89017L11.7233 3.74074C11.8171 3.64697 11.9442 3.59429 12.0768 3.59429Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.47463 10.4996C3.47463 10.2234 3.69849 9.99957 3.97463 9.99957H20.0044C20.2806 9.99957 20.5044 10.2234 20.5044 10.4996C20.5044 10.7757 20.2806 10.9996 20.0044 10.9996H3.97463C3.69849 10.9996 3.47463 10.7757 3.47463 10.4996Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDowntown);
export default __webpack_public_path__ + "static/media/downtown.eb17fa7d0c65beef613ec2c25a67e52a.svg";
export { ForwardRef as ReactComponent };